import { fieldApi } from './maptualApiClient';

export const getCategoricalDataByHCP = (projectId: string, entityId: string) =>
  fieldApi.getCategoricalData({
    projectId,
    entityId,
  });
